module.exports = __webpack_public_path__ + "static/media/07.83bcce9a.jpg";